import { useAccount } from 'wagmi';
import { useEffect, useState } from 'react';
import { HexString } from '@/lib/config/wagmi';

export function useWatchAccount(
  onAccountChange: (address: HexString | undefined) => void | Promise<void>,
) {
  const { address } = useAccount();
  const [oldAddress, setOldAddress] = useState<HexString | undefined>(
    undefined,
  );
  useEffect(() => {
    if (oldAddress !== address) {
      setOldAddress(address);
      onAccountChange(address);
    }
  }, [address, oldAddress, onAccountChange]);
}
